// extracted by mini-css-extract-plugin
export default {"root":"Wgu1E","icon":"_2Ys27"};